import React from 'react'

import { LogicDebug } from '../components/LogicDebug'
import { ShortlistEmptyStateIcon } from '../components/Svg'
import { SystemCard } from '../components/SystemCard'
import { systemMatchesAllFilters } from '../helpers/systems'
import { useWpIsLoggedIn } from '../hooks/useWpIsLoggedIn'
import { useFiltersStore } from '../state/filtersStore'
import { useNavigationStore } from '../state/navigationStore'
import { useWpDataStore } from '../state/wpDataStore'

const SystemsTab = () => {
  const isLoggedIn = useWpIsLoggedIn()

  const appliedFilters = useFiltersStore((state) => state.appliedFilters)
  const systemFilters = appliedFilters.filter((f) => f.applies_to === 'systems')

  const { systems, loading, error } = useWpDataStore()

  // Only show systems that matches all applied filters = shortlist
  const filteredSystems =
    systems?.filter((system) =>
      systemMatchesAllFilters(system, systemFilters)
    ) ?? []

  if (loading && error) return null

  return (
    <div>
      {isLoggedIn && <LogicDebug />}

      {/* {systemFilters && systemFilters.length > 0 ? (
        <> */}
      {!filteredSystems?.length ? (
        <EmptyStateNoMatchingFilters />
      ) : (
        <ul className='system-list'>
          {filteredSystems.map((systemPost) => {
            const { id } = systemPost

            return (
              <li key={id} className='system-list__item'>
                <SystemCard systemPost={systemPost} />
              </li>
            )
          })}
        </ul>
      )}
      {/* </>
      ) : (
        <EmptyStateNoAppliedFilters />
      )} */}
    </div>
  )
}

const EmptyStateNoAppliedFilters = () => {
  const navigateTab = useNavigationStore((state) => state.navigateTab)
  const setWizardOpen = useNavigationStore((state) => state.setWizardOpen)

  const selectFirstGuideFilter = useFiltersStore(
    (state) => state.selectFirstGuideFilter
  )

  return (
    <div className='shortlist-tab__empty-state'>
      <div className='shortlist-tab__empty-state-content'>
        <ShortlistEmptyStateIcon />

        <h4>Get your shortlist!</h4>

        <p>
          Use our{' '}
          <a
            href='#'
            onClick={(e) => {
              e.preventDefault()
              selectFirstGuideFilter()
              setWizardOpen(true)
            }}
          >
            Smart Guide
          </a>{' '}
          or the Filters to start building the shortlist of the optimal systems
          for your project.
        </p>

        {/* <p>
          You can also browse{' '}
          <a
            href='#'
            onClick={(e) => {
              e.preventDefault()
              navigateTab('cases')
            }}
          >
            All Case Studies
          </a>
          .
        </p> */}
      </div>
    </div>
  )
}

const EmptyStateNoMatchingFilters = () => {
  const navigateTab = useNavigationStore((state) => state.navigateTab)
  const setWizardOpen = useNavigationStore((state) => state.setWizardOpen)

  const selectFirstGuideFilter = useFiltersStore(
    (state) => state.selectFirstGuideFilter
  )

  return (
    <div className='shortlist-tab__empty-state'>
      <div className='shortlist-tab__empty-state-content'>
        <ShortlistEmptyStateIcon />

        <h4>No match!</h4>

        <p>No systems match your applied filters.</p>
      </div>
    </div>
  )
}

export { SystemsTab }
